import React from 'react'
import * as R from 'remeda'

import { type DisplayRowItem } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { type DisplayRowId, type RowData } from '../utils'

import { useSortFunc } from './useSortFunc'

type DisplayRowItemsParams<T extends RowData<string>> = {
  getLabel: (rowsData: T[]) => string
  getRowId: (rowData: T) => DisplayRowId
  getSubLabel: (rowData: T) => string
}

export const useDisplayRowItems = <T extends RowData<string>>(
  tableType: 'individual' | 'matrix' | 'sequential',
  rowsArrayData: T[][],
  { getLabel, getRowId, getSubLabel }: DisplayRowItemsParams<T>,
) => {
  const sortFunc = useSortFunc(`${tableType}SortValue`)
  const hiddenRowIds = useAtomValueContext('hiddenRowIds')

  return React.useMemo<DisplayRowItem<DisplayRowId>[]>(
    () =>
      rowsArrayData.map(
        R.piped(sortFunc, (rowsData) => ({
          label: getLabel(rowsData),
          subItems: rowsData.map((rowData) => {
            const id = getRowId(rowData)

            return {
              id,
              isVisible: !hiddenRowIds.includes(id),
              label: getSubLabel(rowData),
            }
          }),
        })),
      ),
    [getLabel, getRowId, getSubLabel, hiddenRowIds, rowsArrayData, sortFunc],
  )
}
